
/*
 * This extension is used to zoom in on an image when the user hovers over it. It reveals the spellify card when
 * hovering over the card image on the Spellify page. These functions are used to hide the preview.
 *
 * https://chromewebstore.google.com/detail/hover-zoom+/pccckmaobkjjboncdfnnofkonhgpceea?pli=1
 */


export const hidePreview = () => {
  const styles = `
     #hzViewer {
        display: none !important;
        opacity: 0 !important;
      }
  `
  const styleSheet = document.createElement("style")
  styleSheet.type = "text/css"
  styleSheet.innerText = styles
  styleSheet.id = 'hzViewerRemover'
  document.head.appendChild(styleSheet)
}

export const showPreview = () => {
  const styleSheet = document.getElementById('hzViewerRemover')
  if (styleSheet) {
    styleSheet.remove()
  }
}